<template>
  <header class="topbar">
    <router-link to="/">
      <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 134.8"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M536,32.54H478.72L467.62,0h-21L435.56,32.54H380.62V0h-17.4V32.54h-81V14.6h55.4V0h-72.8V32.54h-30.2V0H217V32.54h-65.2V0h-17.4V32.54H78.22V14.8h41.2V0H19.62V14.8h41V32.54H0v72H60.62V134.8h17.6V104.54h56.2V134.8h17.4V104.54H217V134.8h17.6V104.54h30.2V134.8h75.8V120.2h-58.4V104.54h81V134.8h17.4V104.54H411.1L400.82,134.8h18l10-30.26h55.93L495,134.8h18.6l-10.32-30.26H536Zm-84.18,0c1.68-5.77,3.19-11.5,4.6-17.14h.4c1.42,5.54,2.84,11.18,4.62,17.14Z"/></g></g></svg>
    </router-link>
    <div class="controls">
      <div class="user">
        <span class="ficon"></span> Team Theia
      </div>
<!--      <div class="help">-->
<!--        <span class="ficon"></span>-->
<!--      </div>-->
<!--      <div class="exit">-->
<!--        <span class="ficon"></span>-->
<!--      </div>-->
    </div>
  </header>
</template>

<script>
export default {
  name: 'TTopBar',
};
</script>

<style scoped lang='scss'>
  @import "../assets/scss/theme";

  .topbar {
    /*width: 100vw;*/
    height: 4rem;
    border-bottom: 2px solid $creme100;
    padding-left: 2rem;
    padding-right: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      height: 2rem;
      fill: $dark100;
    }

    .controls {
      display: flex;
      font-size: 1.125rem;

      >* {
        margin-left: 1rem;
        padding: 0.5rem;
        border-radius: 4px;
        /*cursor: pointer;*/
        cursor: default;

        /*&:hover {*/
        /*background: $creme75;*/
        /*}*/
      }

      .help, .exit {
        height: 2rem;
        width: 2rem;
        text-align: center;
      }

      .user {
        margin-left: 0;
        display: flex;
        align-items: center;
        /*padding: 0 1rem;*/

        span {
          margin-right: 1rem;
        }
      }

      .ficon {
        font-size: 1.5rem;
      }
    }
  }
</style>
